// The optional report header a form carries: free text plus an optional logo,
// shown above the questions when a survey is filled in, viewed, or exported.
// Stored inside the form schema JSON, so no per-form column is needed.

export const HEADER_POSITIONS = [
  { value: 'left', label: 'Left' },
  { value: 'center', label: 'Center' },
  { value: 'right', label: 'Right' },
];

export const DEFAULT_LOGO_POSITION = 'right';

// Bounded so a pasted document can't be smuggled into the schema; the API
// enforces the same ceiling.
export const MAX_HEADER_TEXT = 1000;

const isPosition = (value) => HEADER_POSITIONS.some((entry) => entry.value === value);

// Coerce whatever is on the schema into the full header shape. Forms saved
// before headers existed simply come back empty.
export const normalizeHeader = (raw) => ({
  text: typeof raw?.text === 'string' ? raw.text.slice(0, MAX_HEADER_TEXT) : '',
  logo: typeof raw?.logo === 'string' ? raw.logo : '',
  logoPosition: isPosition(raw?.logoPosition) ? raw.logoPosition : DEFAULT_LOGO_POSITION,
});

export const getFormHeader = (schema) => normalizeHeader(schema?.header);

// Nothing to draw when the author left both the text and the logo empty.
export const hasHeaderContent = (header) => Boolean(header?.text?.trim() || header?.logo);
